import { InputProps } from 'antd/lib/input';
import { useCallback } from 'react';
import * as React from 'react';
import { Field } from 'redux-form';
import { Country } from '../../../models/country';
import { CountryCodeSelectOption } from '../../country-code/country-code.select-options';
import { FormSelectInput } from '../../form-inputs/form-select-input/form-select-input';
import { FormTextInput } from '../../form-inputs/form-text-input/form-text-input';
import { filterPhoneOption } from './form-field-phone.logic';

interface FormFieldPhoneProps extends InputProps {
  countryCodeFieldName: string;
  name: string;
  inProgress?: boolean;
  countryCode: string | undefined;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  countryCodeOptions: CountryCodeSelectOption[];
}

export const FormFieldPhone: React.FC<FormFieldPhoneProps> = ({
  countryCodeFieldName,
  inProgress,
  name,
  countryCode,
  label,
  placeholder,
  disabled = false,
  countryCodeOptions,
  ...rest
}) => {
  const renderTag = useCallback((tag: Country | undefined) => tag?.country_code, []);
  return (
    <Field<any>
      addonBefore={
        <Field
          name={countryCodeFieldName}
          component={FormSelectInput}
          className={'country-code'}
          options={countryCodeOptions}
          disabled={disabled || inProgress}
          isInsideOtherField
          showSearch
          filterOption={filterPhoneOption}
          optionLabelProp={'label'}
          dropdownMatchSelectWidth={false}
          renderTag={renderTag}
        />
      }
      name={name}
      component={FormTextInput}
      label={label}
      placeholder={placeholder}
      onlyNumbers
      formItemClassName="phone-number-validation-message"
      {...rest}
    />
  );
};
